<template>
  <div>
    <apexchart
      type="bar"
      height="250"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "App",
  props: {
    chartData: {
      name: [],
      data: [],
    },
  },
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      series: [],
      chartOptions: {
        legend: {
          position: "top",
          fontSize: "14px",
        },
        chart: {
          type: "bar",
          height: 350,
        },
        menu: {
          offsetY: 10,
          offsetX: 10,
          fontSize: "14px",
          width: 150,
        },
        colors: ["#F9C228"],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "75%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ['#000'], // Defina a cor do texto dos números (preto aqui)
          },
          formatter: function (val) {
            return val; // Aqui você pode personalizar a exibição, caso precise formatar os números
          },
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [],
          position: "bottom",
        },
        fill: {
          opacity: 1,
        },
        noData: {
          text: this.$t('alerta.alerta_numresultado'),
          align: "center",
          verticalAlign: "middle",
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: "16px",
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
      },
    };
  },
  created() {
    this.updateData();
  },
  methods: {
    updateData() {
      setTimeout(() => {
        const { name, data } = this.chartData;
        this.series = [{ name: this.$t('student.student_acesso.acesso'), data: data }];
        this.chartOptions = {
          xaxis: {
            categories: name,
          },
        };
      }, 500);
    },
  },
};
</script>

<style></style>
